export const EDITABLE_FIELDS = ['RATING', 'TEAM', 'ANALYST'];
export const RATING_CHOICES = ['', '1', '2', '3', '4', '5', '6', 'N/A - Paid Off'];
export const WORKSHEET_COLUMNS = [
  ['CUSIP', 'Identifier'],
  ['DES', 'Description'],
  ['RATING', 'Current Rating (1–6)'],
  ['TEAM', 'Current Team'],
  ['ANALYST', 'Current Analyst'],
  ['ANALYST_ABBREVIATION', 'Analyst Abbreviation'],
  ['ASSET_LVL_1', 'Asset Type — Level 1'],
  ['ASSET_LVL_2', 'Asset Type — Level 2'],
  ['ASSET_LVL_3', 'Asset Type — Level 3'],
  ['STAT_CARRYING_VALUE', 'STAT Carrying Value'],
  ['GAAP_CARRYING_VALUE', 'GAAP Carrying Value'],
  ['MARKET_VAL', 'Market Value'],
  ['STAT_UNREALIZED_GAIN_LOSS', 'STAT Unrealized Gain/Loss'],
  ['GAAP_UNREALIZED_GAIN_LOSS', 'GAAP Unrealized Gain/Loss'],
  ['STAT_BOOK_YIELD', 'STAT Yield'],
  ['GAAP_BOOK_YIELD', 'GAAP Yield'],
  ['MARKET_YIELD', 'Market Yield'],
  ['WAL', 'WAL'],
  ['DURATION', 'Effective Duration'],
  ['MODIFIED_BY', 'Modified By'],
  ['MODIFIED_DATE', 'Modified Date'],
];
export const PERCENT_FIELDS = ['STAT_BOOK_YIELD', 'GAAP_BOOK_YIELD', 'MARKET_YIELD'];
export const NUMERIC_FIELDS = [
  'STAT_CARRYING_VALUE',
  'GAAP_CARRYING_VALUE',
  'MARKET_VAL',
  'STAT_UNREALIZED_GAIN_LOSS',
  'GAAP_UNREALIZED_GAIN_LOSS',
  'STAT_BOOK_YIELD',
  'GAAP_BOOK_YIELD',
  'MARKET_YIELD',
  'WAL',
  'DURATION',
];

const isBlank = (value) => value == null || String(value).trim() === '';
export const editableRecord = (row) =>
  Object.fromEntries(
    ['CUSIP', ...EDITABLE_FIELDS].map((field) => [field, isBlank(row[field]) ? null : row[field]])
  );

export function validateRatings(records) {
  const errors = [];
  records.forEach((row) => {
    if (!row.CUSIP) errors.push('An identifier is required.');
    if (!RATING_CHOICES.includes(String(row.RATING ?? '').trim())) {
      errors.push(`${row.CUSIP}: Current Rating must be 1–6, N/A - Paid Off, or blank.`);
    }
  });
  return errors;
}

export function formatRatingValue(field, value) {
  if (isBlank(value)) return '';
  if (field === 'MODIFIED_DATE') return new Date(value).toLocaleString();
  if (
    PERCENT_FIELDS.includes(field) &&
    !Number.isFinite(Number(value))
  )
    return String(value);
  if (PERCENT_FIELDS.includes(field)) return `${Number(value).toFixed(4)}%`;
  if (NUMERIC_FIELDS.includes(field)) {
    const number = Number(value);
    return Number.isFinite(number)
      ? number.toLocaleString(undefined, { maximumFractionDigits: 6 })
      : String(value);
  }
  return String(value);
}

export const filterRatings = (rows, filters) =>
  rows.filter((row) =>
    Object.entries(filters).every(
      ([field, choice]) =>
        choice === '' || (choice === '__unassigned__' ? isBlank(row[field]) : row[field] === choice)
    )
  );
